import React, { useEffect, useState } from "react";
import { Building, CheckCircle, CheckCircle2, Clock, DollarSign, Inbox, Loader2, MapPin, Truck,Package, Phone, Timer, User, UserPlus, X } from "lucide-react";
import {  faTimes , faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ExtendTimePopup from './ExtendTimePopup'
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {Loader} from '../Loader/Loader';
import Search from '../Components/Search';
import Pagination, { usePagination } from '../Components/Pagination';
import { useNavigate } from "react-router-dom";
// 🕒 Calculate remaining time
const calculateRemainingTime = (time_expired_at) => {
  if (!time_expired_at) return "--";

  const expiry = new Date(time_expired_at).getTime();
  const now = Date.now();
  const diff = expiry - now;

  if (diff <= 0) return "Time Completed";

  const minutes = Math.floor(diff / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);

  return `${minutes}m ${seconds}s`;
};


// 🎨 Status Badge
const getStatusBadgeClass = (status) => {
  switch (status) {
    case "Order Confirmed":
      return "bg-green-100 text-green-700 border-green-300";
    case "Waiting For Supplier Responses":
      return "bg-yellow-100 text-yellow-700 border-yellow-300";
    case "Waiting For Payment":
      return "bg-orange-100 text-orange-700 border-orange-300";
    case "Cancelled":
      return "bg-red-100 text-red-700 border-red-300";
    default:
      return "bg-gray-100 text-gray-700 border-gray-300";
  }
};

// 🔴🟡🟢 urgency dots
/* const getUrgencyIndicator = (status) => {
  switch (status) {
    case "Waiting For Supplier Responses":
      return <span className="h-3 w-3 rounded-full bg-yellow-500 animate-pulse" />;
    case "Waiting For Payment":
      return <span className="h-3 w-3 rounded-full bg-red-500 animate-pulse" />;
    case "Order Confirmed":
      return <span className="h-3 w-3 rounded-full bg-green-500" />;
    default:
      return <span className="h-3 w-3 rounded-full bg-gray-400" />;
  }
}; */

// 🕒 Urgency dot based on remaining time percentage
/* const getUrgencyIndicator = (countdown, totalTimeMinutes) => {
  try {
    if (!countdown || countdown === "--" || !totalTimeMinutes) {
      return <span className="h-3 w-3 rounded-full bg-gray-400  text-center" />;
    }

    // ⏱ Extract minutes + seconds from countdown (e.g., "12m 30s")
    const match = countdown.match(/(\d+)m\s*(\d*)s?/);
    if (!match) {
      // If countdown string is "Time Completed" or invalid
      return <span className="h-3 w-3 rounded-full bg-gray-400 text-center" />;
    }

    const minutesLeft = parseInt(match[1]) || 0;
    const secondsLeft = parseInt(match[2]) || 0;
    const totalSecondsLeft = minutesLeft * 60 + secondsLeft;
    const totalSeconds = totalTimeMinutes * 60;

    // ✅ Remaining ratio (0 to 1)
    const remainingRatio = totalSecondsLeft / totalSeconds;

    // 🔵🟡🔴 Color logic
    if (remainingRatio > 0.6) {
      // More than 60% time left → blue (safe)
      return <span className="h-3 w-3 rounded-full bg-blue-500 text-center" />;
    } else if (remainingRatio > 0.3) {
      // Between 30% and 60% → yellow (medium urgency)
      return <span className="h-3 w-3 rounded-full bg-yellow-500 animate-pulse text-center" />;
    } else if (remainingRatio > 0) {
      // Less than 30% → red (high urgency)
      return <span className="h-3 w-3 rounded-full bg-red-500 animate-pulse text-center" />;
    } else {
      // Expired or no time left
      return <span className="h-3 w-3 rounded-full bg-gray-400 text-center" />;
    }
  } catch {
    return <span className="h-3 w-3 rounded-full bg-gray-400 text-center" />;
  }
}; */

const getUrgencyIndicator = (countdown) => {
  try {
    if (!countdown || countdown === "--" || countdown === "Time Completed") {
      return <span className="h-3 w-3 rounded-full bg-gray-400 text-center" />;
    }

    // ⏱ Extract minutes + seconds from countdown (e.g., "6m 16s")
    const match = countdown.match(/(\d+)m\s*(\d*)s?/);
    if (!match) {
      // Invalid format
      return <span className="h-3 w-3 rounded-full bg-gray-400 text-center" />;
    }

    const minutesLeft = parseInt(match[1]) || 0;
    const secondsLeft = parseInt(match[2]) || 0;
    const totalSecondsLeft = minutesLeft * 60 + secondsLeft;

    // 🔵🟡🔴 Color logic based on absolute remaining time
    if (totalSecondsLeft > 1200) {  // More than 20 minutes
      return <span className="h-3 w-3 rounded-full bg-blue-500 text-center" />;
    } else if (totalSecondsLeft > 600) {  // 10-20 minutes
      return <span className="h-3 w-3 rounded-full bg-yellow-500 animate-pulse text-center" />;
    } else if (totalSecondsLeft > 0) {  // Less than 10 minutes
      return <span className="h-3 w-3 rounded-full bg-red-500 animate-pulse text-center" />;
    } else {
      // Expired or 0 time left
      return <span className="h-3 w-3 rounded-full bg-gray-400 text-center" />;
    }
  } catch (error) {
    console.error('Error in getUrgencyIndicator:', error);
    return <span className="h-3 w-3 rounded-full bg-gray-400 text-center" />;
  }
};


const RFQsTable = () => {
  const navigate = useNavigate();
  const [rfqs, setRfqs] = useState([]);
  const [filteredRFQs, setFilteredRFQs] = useState([]);
  const [countdowns, setCountdowns] = useState({});
  const [loading, setLoading] = useState(false);
  const [responsesLoading, setResponsesLoading] = useState(false);
  const [supplierResponsesPopupOpen, setSupplierResponsesPopupOpen] = useState(false);
  const [supplierResponses, setSupplierResponses] = useState([]);
  const imageurl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;
    // 🔹 State for RFQ item details popup
const [isItemsModalOpen, setIsItemsModalOpen] = useState(false);
const [activeTab, setActiveTab] = useState("RFQ Summary");
const [rfqItemResponses, setRFQItemResponses] = useState([]);
const [rfqLoading, setRfqLoading] = useState(false);
const [RFQNumber, setRFQNumber] = useState('')

// 🔹 Supplier Item Popup
const [selectedSupplier, setSelectedSupplier] = useState(null);
const [supplierItems, setSupplierItems] = useState([]);
const [supplierItemsLoading, setSupplierItemsLoading] = useState(false);
const [supplierItemsPopupOpen, setSupplierItemsPopupOpen] = useState(false);
const [showExtendPopup, setShowExtendPopup] = useState(false);
const [selectedRFQ, setSelectedRFQ] = useState(null)

// 🔹 State for Customer Info
const [customerInfo, setCustomerInfo] = useState(null);
const [customerInfoLoading, setCustomerInfoLoading] = useState(false);

// 🧩 Tracking state
const [trackingData, setTrackingData] = useState(null);
const [trackingLoading, setTrackingLoading] = useState(false);
const [assignPopupOpen, setAssignPopupOpen] = useState(false);
const [suppliers, setSuppliers] = useState([]);
const [selectedSuppliers, setSelectedSuppliers] = useState([]);
const [assignLoading, setAssignLoading] = useState(false);

const [finalPricePopupOpen, setFinalPricePopupOpen] = useState(false);
const [finalPriceMode, setFinalPriceMode] = useState(""); // "AUTO" or "SPECIFIC"
const [selectedSupplierForFinalPrice, setSelectedSupplierForFinalPrice] = useState(null);
const [finalSupplierSelectPopup, setFinalSupplierSelectPopup] = useState(false);
 const [showPopup, setShowPopup] = useState(false);
  // BuildCoins modal state (like Orders)
  const [coinsToGive, setCoinsToGive] = useState("");
  const [crediting, setCrediting] = useState(false);
  const [creditResult, setCreditResult] = useState({ success: false, message: '' });
  const [showCreditResult, setShowCreditResult] = useState(false);
  const [customerId, setCustomerId] = useState(null);
  const [rfqId, setRfqId] = useState(null);
  const searchTypes = ["RFQ Number", "Customer", "Status"];
  const [persistedSearchQuery, setPersistedSearchQuery] = useState("");
const [persistedSearchType, setPersistedSearchType] = useState("");
const [searchChips, setSearchChips] = useState(() => {
  const saved = localStorage.getItem('rfqsSearchChips');
  return saved ? JSON.parse(saved) : [];
});

useEffect(() => {
  localStorage.setItem('rfqsSearchChips', JSON.stringify(searchChips));
}, [searchChips]);


const {
  currentItems,
  currentPage,
  totalPages,
  totalItems,
  handlePageChange,
  handlePreviousPage,
  handleNextPage,
  resetToFirstPage
} = usePagination(filteredRFQs, 10);

const handleAddChip = (query, type) => {
   if (!type) return;

  const actualQuery = query.trim();

  setSearchChips((prev) => {
    const exists = prev.some(
      (chip) => chip.query === actualQuery && chip.type === type
    );
    if (exists) return prev;

     const updated = [...prev, { query: actualQuery, type }];
    localStorage.setItem('projectSearchChips', JSON.stringify(updated));
    return updated;
  });
setPersistedSearchQuery(actualQuery);
  setPersistedSearchType(type);
  handleSearch(actualQuery, type);
};


// Remove Chip
const handleRemoveSearchChip = (chipToRemove) => {
  const updated = searchChips.filter(
    (chip) =>
      !(chip.query === chipToRemove.query && chip.type === chipToRemove.type)
  );
setSearchChips(updated);
  localStorage.setItem('rfqsSearchChips', JSON.stringify(updated));  if (updated.length === 0) {
    setFilteredRFQs(rfqs);
    setPersistedSearchQuery('');
    setPersistedSearchType('');
    return;
  }
  const last = updated[updated.length - 1];
  handleSearch(last.query, last.type);
};


const handleChipClick = (chip) => {
  setPersistedSearchQuery(chip.query);
  setPersistedSearchType(chip.type);
  handleSearch(chip.query, chip.type);
};

// Search handler
const handleSearch = (query, type) => {
  if (!type && query === "") {
    setFilteredRFQs(rfqs);
    resetToFirstPage(); 
    return;
  }

  const lowercaseQuery = (query || "").toLowerCase();

  const filtered = rfqs.filter((rfq) => {
    switch (type) {
      case "RFQ Number":
        return rfq.rfq_number?.toLowerCase().includes(lowercaseQuery);

      case "Customer":
        return rfq.customer?.name?.toLowerCase().includes(lowercaseQuery);

      case "Status":
        return rfq.status?.toLowerCase().includes(lowercaseQuery);

      default:
        return true;
    }
  });

  setFilteredRFQs(filtered);
    resetToFirstPage(); 
};

  // ✅ Fetch RFQs
  const fetchRFQs = async () => {
    setLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-all-customer-Rfqs`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json", "x-token": token },
        }
      );
      const resData = await response.json();
      const data = resData?.data || [];
      setRfqs(data);
      setFilteredRFQs(data);
    } catch (error) {
      console.error("Error fetching RFQs:", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRFQs();
  }, []);

 

  // ⏱ Timer updates
  useEffect(() => {
  const interval = setInterval(() => {
    const updated = {};

    filteredRFQs.forEach((rfq) => {
      updated[rfq._id] = calculateRemainingTime(rfq.time_expired_at);
    });
  //console.log(updated)
    setCountdowns(updated);
  }, 1000);

  return () => clearInterval(interval);
}, [filteredRFQs]);


  // 📦 Fetch Supplier Responses
  const handleGetSupplierResponses = async (quotation_id) => {
    try {
      const token = sessionStorage.getItem("token");
      const res = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-rfq-requests-and-responces-of-supplier?quotation_id=${quotation_id}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json", "x-token": token },
        }
      );
      //console.log(res)
      const data = await res.json();
     console.log(data)
      if (data.success && data.data.length > 0) return data.data;
      return [];
    } catch (error) {
      console.error("Error fetching supplier responses:", error);
      return [];
    }
  };

  // 👁 View Responses Popup
  const handleViewResponses = async (rfq) => {
    setResponsesLoading(true);
    setSupplierResponsesPopupOpen(true);
    setSelectedRFQ(rfq)
    const responses = await handleGetSupplierResponses(rfq.quotation_id);
    //console.log(responses)
    setSupplierResponses(responses);
    setResponsesLoading(false);
  };



// 🔹 Fetch RFQ item response details
const getRFQItemResponseDetails = async (rfqId, rfq_number) => {
  try {
    setRfqLoading(true);
    setRFQNumber(rfq_number)
    const token = sessionStorage.getItem("token");
    if (!token) {
      console.error("Authentication required. Please log in again.");
      return;
    }

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-rfq-item-response-details?RFQId=${encodeURIComponent(
        rfqId
      )}`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );

    const result = await response.json();
    if (result.success) {
      console.log("RFQ Item Response Details:", result.data);
      setRFQItemResponses(result.data);
    } else {
      console.error(
        "Failed to fetch RFQ item response details:",
        result.message
      );
      setRFQItemResponses([]);
    }
  } catch (error) {
    console.error("Error fetching RFQ item response details:", error);
    setRFQItemResponses([]);
  } finally {
    setRfqLoading(false);
    setIsItemsModalOpen(true);
    //setActiveTab("items");
  }
};

// 🔹 Fetch Customer RFQ Info API
const getCustomerRFQInfo = async (rfqId) => {
  try {
    setCustomerInfoLoading(true);
    const token = sessionStorage.getItem("token");
    if (!token) return;

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-customer-rfq-info?RFQId=${rfqId}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json", "x-token": token },
      }
    );

    const result = await response.json();
    if (result.success) {
      setCustomerInfo(result.data);
    } else {
      setCustomerInfo(null);
    }
  } catch (err) {
    console.error("Error fetching customer RFQ info:", err);
    setCustomerInfo(null);
  } finally {
    setCustomerInfoLoading(false);
  }
};

// 🔹 Fetch Tracking Info
const getRFQTrackingInfo = async (rfqId) => {
  try {
    setTrackingLoading(true);
    const token = sessionStorage.getItem("token");
    if (!token) return;

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-rfq-tracking-info?RFQId=${encodeURIComponent(
        rfqId
      )}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json", "x-token": token },
      }
    );

    const result = await response.json();
    if (result.success) {
      setTrackingData(result.data);
    } else {
      setTrackingData(null);
    }
  } catch (error) {
    console.error("Error fetching tracking info:", error);
    setTrackingData(null);
  } finally {
    setTrackingLoading(false);
  }
};

const handleOpenRFQPopup = async (rfqIdParam, rfq_number,rfq) => {
  setCustomerId(rfq.customer.id);
  setRfqId(rfqIdParam);
   await getRFQTrackingInfo(rfqIdParam);
  await getRFQItemResponseDetails(rfqIdParam, rfq_number);
  await getCustomerRFQInfo(rfqIdParam);
  setIsItemsModalOpen(true);
  setActiveTab("RFQ Summary");
};

// API call for crediting BuildCoins (rewards service)
const creditOrderCoins = async (consumerId, rfqId, coinsAmount) => {
  try {
    const token = sessionStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
      'x-token': token
    };

    const res = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}rewards/credit-order-coins`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ consumer_id: consumerId, order_id: rfqId, coins_amount: coinsAmount })
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    return await res.json();
  } catch (error) {
    console.error('Error crediting coins:', error);
    return { success: false, message: error.message };
  }
};

// Handler invoked when admin clicks Give in the BuildCoins popup
const handleGiveCoins = async () => {
  if (!coinsToGive || Number(coinsToGive) <= 0) {
    console.error('Enter a valid BuildCoins amount');
    return;
  }

  // derive consumer id from fetched customer info if available
  const consumerId = customerId;
  if (!consumerId) {
    console.error('Consumer id not available');
    return;
  }

  setCrediting(true);
  try {
    const rfqIdToUse = rfqId || selectedRFQ?._id || null;
    const res = await creditOrderCoins(consumerId, rfqIdToUse, Number(coinsToGive));
    console.log('Credit response:', res);

    const wasSuccessful = (res && (res.success === true || res.total_credited > 0));
    if (wasSuccessful) {
      setCreditResult({ success: true, message: res.message || `Credited ${res.total_credited || coinsToGive} BuildCoins` });
      setShowPopup(false);
      setCoinsToGive("");
    } else {
      setCreditResult({ success: false, message: (res && (res.message || JSON.stringify(res))) || 'Failed to credit BuildCoins' });
    }
    setShowCreditResult(true);
    setTimeout(() => setShowCreditResult(false), 3000);
  } catch (err) {
    console.error('Error during credit operation', err);
    setCreditResult({ success: false, message: err.message || 'Error during credit operation' });
    setShowCreditResult(true);
    setTimeout(() => setShowCreditResult(false), 3000);
  } finally {
    setCrediting(false);
  }
};

const getSupplierItemsToRequestAndRespond = async (quickBuyResponseId, supplierData) => {
  try {
    setSupplierItemsLoading(true);
    setSelectedSupplier(supplierData);  // Move this supplier to top
    setSupplierItemsPopupOpen(true);

    const token = sessionStorage.getItem("token");
    if (!token) return;

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-supplier-items-to-request-and-respond?QuickBuyResponseId=${quickBuyResponseId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );

    const res = await response.json();

    if (res.success) {
      setSupplierItems(res.data); // only item list with statuses
      console.log(res.data)
    } else {
      setSupplierItems([]);
    }
  } catch (error) {
    console.error("Error fetching supplier items:", error);
    setSupplierItems([]);
  } finally {
    setSupplierItemsLoading(false);
  }
};

const handleExtendTime = (rfq) => {
  setSelectedRFQ(rfq);
  setShowExtendPopup(true);
};

const handleReactivateRFQ = async (rfq) => {
 // setSelectedRFQ(rfq);
  //setShowExtendPopup(true);
  console.log('it is not implemented at ')
};


const refresh = () => {
  fetchRFQs();
};

const toggleSupplierSelection = (id) => {
  setSelectedSuppliers(prev =>
    prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
  );
};

// Fetch suppliers when popup opens
useEffect(() => {
  if (assignPopupOpen) fetchSuppliersForRFQ();
}, [assignPopupOpen]);

const fetchSuppliersForRFQ = async () => {
  try {
    if (!selectedRFQ?._id) {
      console.error("RFQ ID is missing. Cannot fetch suppliers.");
      return;
    }

    setAssignLoading(true);
    const token = sessionStorage.getItem("token");

    const url = `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-quick-buy-suppliers?rfq_id=${selectedRFQ._id}`;

    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-token": token,
      },
    });

    const data = await res.json();
    console.log(data)
    if (!data.success) {
      console.warn("Failed to fetch suppliers:", data.message);
      setSuppliers([]);
      return;
    }

    setSuppliers(data.suppliers || []);
  } catch (error) {
    console.error("Error fetching suppliers:", error);
    setSuppliers([]);
  } finally {
    setAssignLoading(false);
  }
};


const assignSelectedSuppliers = async () => {
  try {
    const token = sessionStorage.getItem("token");

    const res = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/assign-suppliers-to-RFQ`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json", "x-token": token },
        body: JSON.stringify({
          rfq_id: selectedRFQ._id,
          supplier_ids: selectedSuppliers,
        }),
      }
    );

    const data = await res.json();

    if (data.success) {
      toast.success("Suppliers assigned successfully!");
      const responses = await handleGetSupplierResponses(selectedRFQ.quotation_id);
    //console.log(responses)
    setSupplierResponses(responses);
    setAssignPopupOpen(false);
    setResponsesLoading(false);
      refresh();
    } else {
      toast.error(data.message || "Failed to assign suppliers");
    }
  } catch (e) {
    toast.error("Server error. Try again.");
  }
};

const handleGetFinalPrice = async (mode, supplierId = null) => {
  try {
    const token = sessionStorage.getItem("token");

    const payload = {
      rfq_id: selectedRFQ._id,
      type: mode,
      ...(mode === "SPECIFIC" ? { supplier_id: supplierId } : {})
    };

    const res = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-final-price`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    if (data.success) {
      toast.success("Awarding completed successfully!");
      console.log("FINAL PRICE:", data.final_price);
      setFinalSupplierSelectPopup(false);
      setFinalPricePopupOpen(false);
      const responses = await handleGetSupplierResponses(selectedRFQ.quotation_id);
    //console.log(responses)
    setSupplierResponses(responses);
    } else {
      toast.error(data.message || "Failed to Award");
    }

  } catch (err) {
    console.error(err);
    toast.error("Server error. Try again.");
  }
};

// const handleNavigateAwardingDecision = (rfq) => {
//   if(rfq.status === 'Waiting For Supplier Responses' ){
//  navigate('/bb/app/sales/rfq/adminaward', { state: { rfq_id: rfq._id, rfq_number: rfq.rfq_number } });
//   }
//     navigate('/bb/app/sales/rfq/adminaward', { state: { rfq_id: rfq._id, rfq_number: rfq.rfq_number } });
// };

const formatAmount = (value) => {
  if (!value) return "--";
  return Number(value).toLocaleString("en-US");
};


if (loading) {
  return <Loader />;
}




  // 🧾 MAIN TABLE UI
  return (
    <div className=" bg-white min-h-screen w-full">
      <div className="max-w- full mx-auto">
        <div className="flex space-x-10  py-3 items-center  border-b border-gray-200">
          <h2 className="text-lg font-bold whitespace-nowrap px-3">Customer RFQs</h2>
<div className="flex items-center gap-3">
            <Search
  searchQuery={persistedSearchQuery}
  setSearchQuery={setPersistedSearchQuery}
  searchType={persistedSearchType}
  setSearchType={setPersistedSearchType}
  searchTypes={searchTypes}
  onSearch={handleSearch}
  onSearchSubmit={handleAddChip}
  placeholder="Search RFQS..."
/>

<div className="flex flex-row items-center gap-3  whitespace-nowrap">
  {searchChips.map((chip, index) => {
    const active = chip.type === persistedSearchType;

    return (
      <div
        key={index}
        onClick={() => handleChipClick(chip)}
        className={`flex items-center px-3 py-1 rounded-full text-sm shadow-sm whitespace-nowrap ${
          active ? 'bg-red-500 text-white' : 'bg-gray-100 text-gray-800'
        }`}
      >
        <span className="font-regular">
          {chip.type}
        </span>

        <button
          className="ml-2 font-bold"
          onClick={(e) => {
            e.stopPropagation();
            handleRemoveSearchChip(chip);
          }}
        >
          ×
        </button>
      </div>
    );
  })}
</div>


          </div>
        </div>
         <Pagination
  currentPage={currentPage}
  totalPages={totalPages}
  totalItems={totalItems}
  itemsPerPage={10}
  showInfo={true}
  hideControls={true}
  itemName="Rfqs"
/>

        <div className="bg-white">
         

           {rfqs.length === 0 ? (
          <div className="flex flex-col justify-center items-center h-[100vh] text-gray-500">
  <Inbox size={60} className="mb-4 text-gray-400" />
  <p className="text-lg font-medium">No RFQs found</p>
  <p className="text-sm text-gray-400 mt-1">
    Once customers submit RFQs, they will appear here.
  </p>
</div>

          ) : (
            <div className="overflow-x-auto overflow-y-auto no-scrollbar min-h-[70vh] max-h-[70vh]">
              <table className="min-w-full text-sm text-gray-700 mb-5">
                <thead className=" bg-[#fafafc] text-[#6c7184] border-b sticky top-0 text-xs font-semibold uppercase">
                  <tr>
                    <th className="px-4 py-4 text-center">RFQ #</th>
                     <th className="px-4 py-4 text-center">RFQ Date</th>
                    <th className="px-4 py-4 text-center">Status</th>
                    <th className="px-4 py-4 text-center">Time Left</th>
                    <th className="px-4 py-4 text-center">Responses</th>
                    <th className="px-4 py-4 text-center">Customer</th>
                    <th className="px-4 py-4 text-center">Awarded Suppliers</th>
                    <th className="px-4 py-4 text-center">Total</th>
                  </tr>
                </thead>
                <tbody className="border-b border-gray-200">

                   {currentItems.length === 0 ? (
         <tr>
            <td colSpan="10" className="text-center py-8">
                                        <div className="flex flex-col items-center">
                                          <FontAwesomeIcon
                                            icon={faSearch}
                                            className="text-4xl text-gray-300 mb-4"
                                          />
                                          <p className="text-lg font-medium mb-2 text-gray-700">
                                            No result found.
                                          </p>
                                          <p className="text-sm text-gray-500">
                                            Try adjusting your search criteria.
                                          </p>
                                        </div>
                                      </td>
                      </tr>
                           ) : (
                 currentItems.map((rfq) => {
                    const countdown = countdowns[rfq._id] || "--";
                    const urgency = getUrgencyIndicator(countdown, rfq.time_expired_at);
                    return (
                      <tr key={rfq._id} className="hover:bg-blue-50 transition-colors border-b border-gray-200">
                       {/*  <td className="px-4 py-3 font-medium text-gray-900">{rfq.rfq_number}</td> */}
                        <td
                        className="px-4 py-3 text-center font-medium text-blue-600 hover:underline cursor-pointer"
                        onClick={() => handleOpenRFQPopup(rfq._id, rfq.rfq_number,rfq)}
                      >
                        {rfq.rfq_number}
                      </td>

                       <td
                        className="px-4 py-3 text-center font-medium text-gray-600 hover:underline"
                      >
                         {new Date(rfq.createdAt).toLocaleString("en-IN", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: true
                  })}
                      </td>

                        <td className="px-4 py-3 text-center cursor-pointer"
                        // onClick={() => handleNavigateAwardingDecision(rfq)}
                        >
                          <span
                            className={`px-2 py-1 rounded-full border text-xs font-medium ${getStatusBadgeClass(
                              rfq.status
                            )}`}
                             
                          >
                            {rfq.status}
                          </span>
                        </td>
                        {/*  <td className="px-4 py-3">
                          {countdown === "Time Completed" ? (
                            <div className="flex items-center justify-center w-full">
                              <span className="text-gray-400 text-xs">⏱ Completed</span>
                            </div>
                          ) : (
                            <div className="flex items-center justify-center gap-2 w-full">
                              {urgency}
                              <span className="text-center">{countdown}</span>
                            </div>
                          )}
                        </td> */}
                      {/*   <td className="px-4 py-3 text-center">
 
  {countdown === "Time Completed" ? (
    <div className="flex flex-col items-center justify-center">
      <span className="text-gray-400 text-xs">⏱ Time Completed</span>


      <button
        onClick={() => handleExtendTime(rfq)}
        className="mt-1 text-blue-600 text-xs underline"
      >
        Extend Time
      </button>
    </div>
  ) : (
    // If time is still running
    <div className="flex flex-col items-center gap-1">
      <div className="flex items-center gap-2">
        {urgency}
        <span className="font-medium">{countdown}</span>
      </div>

      
      <button
        onClick={() => handleExtendTime(rfq)}
        className="text-blue-600 text-xs underline"
      >
        Extend Time
      </button>
    </div>
  )}
</td> */}
                      
                      <td className="px-4 py-3 text-center">

                      {/* 1️⃣ ORDER CONFIRMED → show nothing */}
                      {rfq.status === "Order Confirmed" && (
                        <span className="text-gray-400">--</span>
                      )}

                      {/* 2️⃣ CANCELLED → allow REACTIVATE */}
                      {rfq.status === "Cancelled" && (
                        <div className="flex flex-col items-center gap-1">
                          <span className="text-red-500 text-xs font-semibold">--</span>
                          <button
                            onClick={() => handleReactivateRFQ(rfq)}
                            className="text-blue-600 text-xs underline"
                          >
                            Reactivate
                          </button>
                        </div>
                      )}

                      {/* 3️⃣ ACTIVE RFQ STATES (Supplier Response / Payment Waiting) */}
                      {(rfq.status === "Waiting For Supplier Responses" ||
                        rfq.status === "Waiting For Payment") && (
                        <>
                          {countdown === "Time Completed" ? (
                            /* 3A: time completed → allow extend */
                            <div className="flex flex-col items-center gap-1">
                              <span className="text-gray-400 text-xs">⏱ Time Completed</span>
                              <button
                                onClick={() => handleExtendTime(rfq)}
                                className="text-blue-600 text-xs underline"
                              >
                                Extend Time
                              </button>
                            </div>
                          ) : (
                            /* 3B: time running → show countdown + extend */
                            <div className="flex flex-col items-center gap-1">
                              <div className="flex items-center gap-2">
                                {urgency}
                                <span className="font-medium">{countdown}</span>
                              </div>
                              <button
                                onClick={() => handleExtendTime(rfq)}
                                className="text-blue-600 text-xs underline"
                              >
                                Extend Time
                              </button>
                            </div>
                          )}
                        </>
                      )}

                    </td>


                        <td className="px-4 py-3 text-center">
                          <button
                            onClick={() => handleViewResponses(rfq)}
                            className="text-blue-600 font-semibold hover:text-blue-800 hover:underline transition"
                          >
                            {rfq.suppliers?.responded || 0} / {rfq.suppliers?.total || 0}
                          </button>
                        </td>
                        <td className="px-4 py-3 text-center">
                          <p className="font-medium text-gray-800">{rfq.customer?.name || "--"}</p>
                          <p className="text-xs text-gray-500">{rfq.customer?.mobile || ""}</p>
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-700 text-center">
                          {rfq.awarded_suppliers?.length > 0
                            ? rfq.awarded_suppliers.map((s) => s.company_name).join(", ")
                            : "--"}
                        </td>
                        <td className="px-4 py-3 font-semibold text-gray-800 text-center">
                          ₹{rfq.total?.toLocaleString() || 0}
                        </td>
                      </tr>
                    );
                  })
                )}
                  
                </tbody>
              </table>
            </div>
            
          )}
        </div>
      </div>
        <div className="sticky bottom-0 bg-white  z-10 px-4 py-2">

              <Pagination
  currentPage={currentPage}
  totalPages={totalPages}
  totalItems={totalItems}
  itemsPerPage={10}
  onPageChange={handlePageChange}
  onPreviousPage={handlePreviousPage}
  onNextPage={handleNextPage}
  showInfo={false}
  itemName="Rfqs"
/>

        </div>
  
   {/* 🧾 Supplier Responses Popup */}
{supplierResponsesPopupOpen && (
  <div className="fixed inset-0 bg-black/50 backdrop-blur-md flex items-center justify-center z-50 p-4">
    <div className="bg-white w-full max-w-4xl rounded-xl shadow-2xl p-6 relative overflow-hidden">
      {/* Subtle gradient background for depth */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-white opacity-50 pointer-events-none"></div>

       {/* Header */}
      {/* <div className="relative z-10 mb-6 flex justify-between items-center">
        <div>
          <h3 className="text-xl font-bold text-gray-900 flex items-center">
            <Package className="mr-2 text-blue-600" size={24} />
            Supplier Responses
          </h3>
          <p className="text-sm text-gray-600 mt-1">
            Review and manage responses from your suppliers
          </p>
        </div>


        <div className="flex items-center gap-2">
          <button
            onClick={() => {setAssignPopupOpen(true);}}
            className="px-3 py-1.5 bg-blue-600 text-white rounded-md shadow hover:bg-blue-700 transition-all"
          >
            + Assign Suppliers
          </button>

          <button
            className="text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full p-1 transition-all cursor-pointer"
            onClick={() => setSupplierResponsesPopupOpen(false)}
          >
            <FontAwesomeIcon icon={faTimes} size="lg" />
          </button>
        </div>
      </div> */}
      {/* Header */}
<div className="relative z-10 mb-6 flex justify-between items-center">
  <div>
    <h3 className="text-xl font-bold text-gray-900 flex items-center">
      <Package className="mr-2 text-blue-600" size={24} />
      Supplier Responses
    </h3>
    <p className="text-sm text-gray-600 mt-1">
      Review and manage responses from your suppliers
    </p>
  </div>

  {/* ACTION BUTTONS */}
  <div className="flex items-center gap-2">

    {/* Get Final Price */}
    <button
    //  onClick={() => setFinalPricePopupOpen(true)}
       onClick={() =>
    navigate("/bb/app/sales/rfq/adminaward", {
      state: {
        rfq_id: selectedRFQ?._id,
        rfq_number: selectedRFQ?.rfq_number,
      },
    })
  }
      disabled={selectedRFQ?.status === "Order Confirmed"}
      className={`px-3 py-1.5 rounded-md shadow transition-all bg-green-600 text-white hover:bg-green-700`}
    >
      Start Awarding Process
    </button>

    {/* Assign Suppliers */}
    <button
      onClick={() => setAssignPopupOpen(true)}
      disabled={selectedRFQ?.status === "Order Confirmed"}
      className={`px-3 py-1.5 rounded-md shadow transition-all
        ${selectedRFQ?.status === "Order Confirmed"
          ? "bg-gray-300 text-gray-600 cursor-not-allowed"
          : "bg-blue-600 text-white hover:bg-blue-700"
        }`}
    >
      + Assign Suppliers
    </button>

    {/* Close */}
    <button
      className="text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full p-1 transition-all cursor-pointer"
      onClick={() => setSupplierResponsesPopupOpen(false)}
    >
      <FontAwesomeIcon icon={faTimes} size="lg" />
    </button>
  </div>
</div>


      {/* Content */}
      {responsesLoading ? (
        <div className="flex flex-col justify-center items-center py-12 text-gray-500 relative z-10">
          <Loader2 className="animate-spin mb-2" size={32} />
          <p className="text-sm">Fetching responses...</p>
        </div>
      ) : supplierResponses.length === 0 ? (
        <div className="flex flex-col justify-center items-center py-12 text-gray-500 relative z-10">
          <Inbox className="mb-2" size={48} />
          <p className="text-sm">No responses available yet.</p>
        </div>
      ) : (
        <div className="space-y-4 max-h-[60vh] overflow-y-auto relative z-10 pr-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
          {supplierResponses.map((res, i) => (
            <div
              key={i}
              className="border border-gray-200 rounded-lg p-5 bg-white hover:bg-gray-50 hover:shadow-md transition-all duration-200 cursor-pointer"
            >
              {/* Header Row */}
              <div className="flex justify-between items-start mb-3">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                    <Building className="text-blue-600" size={20} />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900 text-base">{res?.vendor.company_name}</p>
                    {/* Added supplier's name below company name */}
                    <p className="text-sm text-gray-700 mt-1">{res?.vendor.name}</p>
                    <div className="flex items-center space-x-4 text-xs text-gray-600 mt-1">
                      <div className="flex items-center">
                        <Phone className="mr-1" size={14} />
                        {res?.vendor?.mobile}
                      </div>
                      <div className="flex items-center">
                        <MapPin className="mr-1" size={14} />
                        {/* Shortened location: Show city/state or integrate a mini map icon */}
                        {res?.vendor?.location.split(',')[0]} {/* Assuming location is "City, State, Country" - show only city */}
                      </div>
                      <div className="flex items-center">
                        <Truck className="mr-1" size={14} />
                        {res?.delivered_by}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Status Badge and Time Left - Better aligned, centered on right */}
                <div className="flex flex-col items-center space-y-2">
                 {/*  <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium text-center ${
                    res.response_status === 'Accepted' ? 'bg-blue-100 text-blue-800' :
                    res.response_status === 'Awarded' ? 'bg-green-100 text-green-800' :
                    res.response_status === 'Waiting for Response' ? 'bg-yellow-100 text-yellow-800' :
                    'bg-red-100 text-red-800'
                  }`}>
                    {res.response_status}
                  </span> */}
                  <span
  className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium text-center ${
    res.response_status === "Accepted"
      ? "bg-blue-100 text-blue-800"
    : res.response_status === "Awarded"
      ? "bg-green-100 text-green-800"
    : res.response_status === "Waiting for Response"
      ? "bg-yellow-100 text-yellow-800"
    : res.response_status === "Counter Offer"
      ? "bg-orange-100 text-orange-800"   // nice distinct color
      : "bg-red-100 text-red-800"
  }`}
>
  {res.response_status === "Counter Offer"
    ? "Counter Offered"
    : res.response_status}
</span>

                  <div className={`flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                    calculateRemainingTime(res.time_expired_at).includes('Expired') ? 'bg-red-100 text-red-700' :
                    calculateRemainingTime(res.time_expired_at).includes('hours') && parseInt(calculateRemainingTime(res.time_expired_at)) < 6 ? 'bg-yellow-100 text-yellow-700' :
                    'bg-blue-100 text-blue-700'
                  }`}>
                    <Timer className="mr-1" size={14} />
                    Time Left: {calculateRemainingTime(res.time_expired_at)}
                  </div>
                </div>
              </div>

              {/* Details Grid */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm text-gray-700">
                          <div
              className="flex items-center cursor-pointer hover:text-blue-600"
              onClick={() => getSupplierItemsToRequestAndRespond(res._id, res)}
            >
              <Package className="mr-2 text-gray-500" size={16} />
              <span className="font-medium underline">{res.items_total} Items</span>
            </div>

                <div className="flex items-center">
                  <DollarSign className="mr-2 text-gray-500" size={16} />
                  <span className="font-medium">₹{res.total.toLocaleString()}</span>
                </div>

                 <div className="flex items-center">
                <Clock className="mr-2 text-gray-500" size={16} />
                <span>
                  Requested:{" "}
                  {new Date(res.requested_time).toLocaleString("en-IN", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: true
                  })}
                </span>
              </div>

               {res.accepted_at && (
  <div className="flex items-center">
    <CheckCircle className="mr-2 text-green-500" size={16} />
    <span>
      Responded: {new Date(res.accepted_at).toLocaleString()}
    </span>
  </div>
)}

              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
)}


{/* 🧾 RFQ Details Popup (Items / Customer / Tracking) */}
{isItemsModalOpen && (
  <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
    <div className="bg-white w-full max-w-5xl rounded-xl shadow-2xl relative p-6">
      {/* Header */}
      <div className="flex justify-between items-center border-b pb-3 mb-4">
        <h2 className="text-xl font-bold text-gray-800 flex items-center">
          <Package className="mr-2 text-blue-600" /> { RFQNumber + " "} Details
        </h2>
        <button
          onClick={() => setIsItemsModalOpen(false)}
          className="text-gray-400 hover:text-red-600"
        >
          <X size={22} />
        </button>
      </div>

      {/* Tabs */}
      <div className="flex border-b mb-4">
        {["RFQ Summary", "items", "customer"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 font-medium text-sm capitalize border-b-2 transition-colors ${
              activeTab === tab
                ? "border-blue-500 text-blue-600"
                : "border-transparent text-gray-500 hover:text-blue-600"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="max-h-[70vh] overflow-y-auto">
      
       {/* 📊 RFQ Summary Tab */}
{activeTab === "RFQ Summary" && (
  <>
    {trackingLoading ? (
      <div className="flex justify-center items-center py-12 text-gray-500">
        <Loader2 className="animate-spin mr-2" /> Loading RFQ summary...
      </div>
    ) : !trackingData ? (
      <div className="flex flex-col justify-center items-center py-16 text-gray-500">
        <Inbox size={48} className="mb-3 text-gray-400" />
        <p>No RFQ summary available.</p>
      </div>
    ) : (
      <div className="space-y-6 text-sm text-gray-700">

        {/* 🧾 RFQ Summary Header */}
        <div className="bg-gray-50 border p-4 rounded-lg shadow-sm">
          <h3 className="text-lg font-semibold text-blue-700 mb-3 flex items-center gap-2">
            <Package size={18} className="text-blue-600" /> RFQ Details
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            <p><span className="font-medium">RFQ Number:</span> {trackingData?.rfq_number}</p>
            <p><span className="font-medium">Status:</span> {trackingData?.current_status}</p>
            <p><span className="font-medium">Suppliers Involved:</span> {trackingData?.total_suppliers}</p>
            <p><span className="font-medium">Items Requested:</span> {customerInfo?.items_summary?.total_requested}</p>
            <p><span className="font-medium">Items Awarded:</span> {customerInfo?.items_summary?.total_awarded}</p>
          </div>
        </div>

        {/* 🕒 Timeline */}
        <div className="relative border-l-2 border-gray-200 pl-6 ml-2">
          {trackingData?.timeline.map((step, index) => (
            <div key={index} className="mb-8 relative">
              <span
                className={`absolute -left-[14px] top-1 w-3 h-3 rounded-full ${
                  step.status === "completed"
                    ? "bg-green-500"
                    : step.status === "pending"
                    ? "bg-yellow-400 animate-pulse"
                    : "bg-gray-300"
                }`}
              ></span>

              <div className="bg-gray-50 border p-4 rounded-lg shadow-sm hover:shadow-md transition">
                <h4 className="font-semibold text-gray-800 flex items-center gap-2">
                  {step.stage}
                  {step.status === "completed" && (
                    <CheckCircle2 size={16} className="text-green-600" />
                  )}
                </h4>
                <p className="text-gray-600 text-sm mt-1">{step.description}</p>
                <p className="text-xs text-gray-400 mt-2">
                  {step.timestamp ? new Date(step.timestamp).toLocaleString() : "--"}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* 💰 Pricing Summary */}
        <div className="bg-gray-50 border p-4 rounded-lg shadow-sm">
          <h3 className="text-lg font-semibold text-blue-700 mb-3 flex items-center gap-2">
            <DollarSign size={18} className="text-blue-600" /> Pricing Summary
          </h3>

          {/* Requested Pricing */}
          <div className="mb-2">
            <h4 className="font-semibold text-gray-800">Requested Price</h4>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-2">
              <p><span className="font-medium">Subtotal:</span>₹{formatAmount(customerInfo?.pricing_summary?.requested?.subtotal)}</p>
              <p><span className="font-medium">Tax:</span>₹{formatAmount(customerInfo?.pricing_summary?.requested?.tax_amount)}</p>
              <p><span className="font-medium">Total:</span>₹{formatAmount(customerInfo?.pricing_summary?.requested?.total)}</p>
            </div>

               <div className="mt-2 flex justify-end">
                         <button
                       className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow active:scale-[0.97]"
                       onClick={() => setShowPopup(true)}
                          >                     
                           Give BuildCoins
                       </button>

                    </div>
          </div>

          {/* Final Pricing */}
          {customerInfo?.pricing_summary?.final && (
            <div>
              <h4 className="font-semibold text-gray-800">Final Price</h4>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-2">
                <p><span className="font-medium">Subtotal:</span> ₹{formatAmount(customerInfo?.pricing_summary?.final.subtotal)}</p>
                <p><span className="font-medium">Tax:</span> ₹{formatAmount(customerInfo?.pricing_summary?.final.tax_amount)}</p>
                <p><span className="font-medium">Total:</span> ₹{formatAmount(customerInfo?.pricing_summary?.final.total)}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    )}
  </>
)}


        {/* 🧱 Items Tab */}
        {activeTab === "items" && (
          <>
            {rfqLoading ? (
              <div className="flex justify-center items-center py-10 text-gray-500">
                <Loader2 className="animate-spin mr-2" /> Loading items...
              </div>
            ) : !rfqItemResponses || rfqItemResponses.length === 0 ? (
              <div className="flex flex-col justify-center items-center py-16 text-gray-500">
                <Inbox size={50} className="mb-3 text-gray-400" />
                <p className="text-lg font-medium">No items placed yet.</p>
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="min-w-full text-sm text-gray-700 border rounded-lg">
                  <thead className="bg-gray-100 text-xs uppercase font-semibold">
                    <tr>
                      <th className="px-4 py-3 text-left">Item Image</th>
                      <th className="px-4 py-3 text-left">Item Name</th>
                      <th className="px-4 py-3 text-left">Req. Price</th>
                      <th className="px-4 py-3 text-left">Response</th>
                      <th className="px-4 py-3 text-left">Final / Best Price</th>
                      <th className="px-4 py-3 text-left">Price Given By</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {rfqItemResponses.map((item, index) => {
                      const summary = item?.response_summary || {};
                      const accepted = summary?.accepted || 0;
                      const counter = summary?.counter_offers || 0;
                      const total = summary?.total_responded || 0;
                      const finalPrice =
                        item?.final_price && item.final_price !== "--"
                          ? `₹${item.final_price}`
                          : item?.best_vendor?.proposed_price
                          ? `Best ₹${item?.best_vendor?.proposed_price}`
                          : "--";

                      return (
                        <tr key={index} className="hover:bg-blue-50 transition-colors">
                          <td className="px-4 py-3">
                            {item?.item_image ? (
                              <img
                                src={imageurl + item?.item_image}
                                alt={item?.item_name || "Item"}
                                className="w-12 h-12 object-cover rounded-md border"
                              />
                            ) : (
                              <div className="w-12 h-12 bg-gray-100 flex items-center justify-center rounded-md">
                                <Package className="text-gray-400" size={18} />
                              </div>
                            )}
                          </td>
                          <td className="px-4 py-3">{item?.item_name || "--"}</td>
                          <td className="px-4 py-3">₹{formatAmount(item?.requested_price || 0)}</td>
                          <td className="px-4 py-3">
                            {accepted + counter}/{total}
                          </td>
                          <td className="px-4 py-3">{finalPrice}</td>
                          <td className="px-4 py-3">
                            {item?.awarded_vendor || "Not Available"}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}

        {/* 👤 Customer Tab */}
{activeTab === "customer" && (
  <>
    {customerInfoLoading ? (
      <div className="flex justify-center items-center py-12 text-gray-500">
        <Loader2 className="animate-spin mr-2" /> Loading customer info...
      </div>
    ) : !customerInfo ? (
      <div className="flex flex-col justify-center items-center py-16 text-gray-500">
        <Inbox size={48} className="mb-3 text-gray-400" />
        <p>No customer information found.</p>
      </div>
    ) : (
      <div className="space-y-6 text-sm text-gray-700">
        
        {/* 👤 Customer Section */}
        <div className="bg-gray-50 border p-4 rounded-lg shadow-sm">
          <h3 className="text-lg font-semibold text-blue-700 mb-3 flex items-center gap-2">
            <User size={18} className="text-blue-600" /> Customer Info
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            <p><span className="font-medium">Name:</span> {customerInfo?.customer.name}</p>
            <p><span className="font-medium">Company:</span> {customerInfo?.customer.company_name}</p>
            <p><span className="font-medium">Email:</span> {customerInfo?.customer.email}</p>
            <p><span className="font-medium">Mobile:</span> {customerInfo?.customer.mobile}</p>
            <p><span className="font-medium">Alternate:</span> {customerInfo?.customer.alternate_mobile}</p>
          </div>
        </div>

        {/* 🏗 Project Section */}
        <div className="bg-gray-50 border p-4 rounded-lg shadow-sm">
          <h3 className="text-lg font-semibold text-blue-700 mb-3 flex items-center gap-2">
            <Building size={18} className="text-blue-600" /> Project Info
          </h3>
          <div className="grid grid-cols-2 gap-4">
            <p><span className="font-medium">Project Name:</span> {customerInfo?.project.name}</p>
            <p><span className="font-medium">Location:</span> {customerInfo?.project.location}</p>
          </div>
        </div>

        {/* 📦 Delivery Address */}
        {customerInfo.delivery_address && (
          <div className="bg-gray-50 border p-4 rounded-lg shadow-sm">
            <h3 className="text-lg font-semibold text-blue-700 mb-3 flex items-center gap-2">
              <MapPin size={18} className="text-blue-600" /> Delivery Address
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              <p><span className="font-medium">Type:</span> {customerInfo?.delivery_address.type}</p>
              <p><span className="font-medium">Area:</span> {customerInfo?.delivery_address.area}</p>
              <p><span className="font-medium">City:</span> {customerInfo?.delivery_address.city}</p>
              <p><span className="font-medium">State:</span> {customerInfo?.delivery_address.state}</p>
              <p><span className="font-medium">Pincode:</span> {customerInfo?.delivery_address.pincode}</p>
            </div>
          </div>
        )}
      </div>
    )}
  </>
)}

     


      </div>
    </div>
  </div>
)}

{supplierItemsPopupOpen && (
  <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4">
    <div className="bg-white w-full max-w-3xl rounded-xl shadow-xl p-6 relative">

      {/* Header */}
      <div className="flex justify-between items-center border-b pb-3 mb-4">
        <h2 className="text-lg font-semibold flex items-center gap-2">
          <Package className="text-blue-600" size={20} />
          Items – {selectedSupplier?.vendor?.company_name}
        </h2>

        <button
          onClick={() => setSupplierItemsPopupOpen(false)}
          className="text-gray-400 hover:text-red-600"
        >
          <X size={20} />
        </button>
      </div>

      {/* Loading */}
      {supplierItemsLoading ? (
        <div className="flex justify-center items-center py-10 text-gray-500">
          <Loader2 className="animate-spin mr-2" /> Loading items...
        </div>
      ) : supplierItems.length === 0 ? (
        <div className="flex flex-col justify-center items-center py-10 text-gray-500">
          <Inbox size={48} className="mb-2" />
          No items found.
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-gray-700 border rounded-lg">
            <thead className="bg-gray-100 text-xs uppercase font-semibold">
              <tr>
                <th className="px-4 py-3">Item</th>
                <th className="px-4 py-3 text-center">Qty</th>
                <th className="px-4 py-3">Requested Price</th>
                <th className="px-4 py-3">Proposed Price</th>
                <th className="px-4 py-3">Status</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-200">
              {supplierItems.map((item, index) => (
                <tr key={index} className="hover:bg-blue-50 transition">
                  
                  {/* Item Image + Name */}
                  <td className="px-4 py-3 flex items-center gap-3">
                    {item.item_image ? (
                      <img
                        src={`${imageurl}${item.item_image}`}
                        alt={item.item_name}
                        className="w-12 h-12 rounded-md object-cover border"
                      />
                    ) : (
                      <div className="w-12 h-12 bg-gray-200 rounded-md flex items-center justify-center">
                        <Package className="text-gray-500" size={18} />
                      </div>
                    )}

                    <span className="font-medium text-gray-800">{item.item_name}</span>
                  </td>

                  {/* Quantity */}
                  <td className="px-4 py-3 text-center">
                    {item.quantity}
                  </td>

                  {/* Quotation Price */}
                  <td className="px-4 py-3 text-gray-800 text-center ">
                    ₹{item.quotation_price}
                  </td>

                  {/* Proposed Price */}
                  <td className="px-4 py-3 text-gray-800 text-center">
                    {item.proposed_price ? `₹${item.proposed_price}` : "--"}
                  </td>

                  {/* Status */}
                  <td className={`px-4 py-3 capitalize font-medium text-center
                    ${item.status === "Accepted" ? "text-green-600" : ""}
                    ${item.status === "Rejected" ? "text-red-600" : ""}
                    ${item.status === "Proposed" ? "text-blue-600" : ""}
                    ${item.status === "Pending" ? "text-gray-500" : ""}
                  `}>
                    {item.status}
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  </div>
)}

{showExtendPopup && selectedRFQ && (
        <ExtendTimePopup
          rfq={selectedRFQ}
          refresh={refresh}
          onClose={() => setShowExtendPopup(false)}
        />
      )}

{assignPopupOpen && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
    <div className="bg-white w-full max-w-lg p-6 rounded-xl shadow-xl relative">

      <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center">
        <UserPlus className="mr-2 text-blue-600" size={20} />
        Assign Suppliers
      </h3>

      <p className="text-sm text-gray-600 mb-4">
        Select suppliers who can supply the items in this RFQ.
      </p>

      {/* Supplier List */}
      <div className="max-h-60 overflow-y-auto border rounded-lg p-3 bg-gray-50">
        {assignLoading ? (
          <div className="text-center py-6 text-gray-500">
            <Loader2 className="animate-spin mx-auto mb-2" />
            Loading suppliers...
          </div>
        ) : suppliers.length === 0 ? (
          <p className="text-gray-500 text-center py-4">No available suppliers found</p>
        ) : (
          suppliers.map((s, idx) => (
            <label key={idx} className="flex items-center p-2 border-b cursor-pointer">
              <input
                type="checkbox"
                value={s.vendor_id}
                onChange={(e) => toggleSupplierSelection(e.target.value)}
                className="mr-3"
              />
              <div>
                <p className="font-medium">{s.vendor_details.company_name}</p>
                <p className="text-xs text-gray-600">
                  {s.items_count} items | {s.vendor_details.mobile_number}
                </p>
              </div>
            </label>
          ))
        )}
      </div>

      {/* Buttons */}
      <div className="flex justify-end gap-2 mt-5">
        <button
          className="px-3 py-1 bg-gray-300 rounded hover:bg-gray-400"
          onClick={() => setAssignPopupOpen(false)}
        >
          Close
        </button>

        <button
  onClick={() => selectedSuppliers.length > 0 && assignSelectedSuppliers()}
  className={`
    px-3 py-1 rounded text-white 
    ${selectedSuppliers.length === 0 
      ? "bg-gray-400 cursor-not-allowed" 
      : "bg-blue-600 hover:bg-blue-700 cursor-pointer"}
  `}
>
  Assign
</button>

      </div>
    </div>
  </div>
)}

{finalPricePopupOpen && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
    <div className="bg-white w-96 rounded-xl shadow-xl p-6">

      <h2 className="text-lg font-bold text-gray-900 mb-3">Start Awarding Process</h2>
      <p className="text-sm text-gray-600 mb-4">
        Choose how you want to Award the  supplier.
      </p>

      <div className="space-y-3">
        {/* Specific Supplier */}
        <button
          onClick={() => {
            setFinalPriceMode("SPECIFIC");
            setFinalPricePopupOpen(false);
            setFinalSupplierSelectPopup(true);
          }}
          className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          To a Specific Supplier
        </button>

        {/* AUTO Supplier */}
        <button
          onClick={() => handleGetFinalPrice("AUTO")}
           disabled={selectedRFQ?.status === "Waiting For Payment"}
      className={`w-full px-4 py-2 rounded-md shadow transition-all
        ${selectedRFQ?.status === "Waiting For Payment"
          ? "bg-gray-300 text-gray-600 cursor-not-allowed"
          : "bg-green-600 text-white hover:bg-green-700"
        }`}
        >
          Award (AUTO)
        </button>
      </div>

      <div className="flex justify-end mt-5">
        <button
          className="px-3 py-1 bg-gray-300 rounded hover:bg-gray-400"
          onClick={() => setFinalPricePopupOpen(false)}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}

{finalSupplierSelectPopup && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
    <div className="bg-white w-96 rounded-xl shadow-xl p-6">

      <h2 className="text-lg font-bold text-gray-900 mb-3">Select Supplier</h2>

      <div className="max-h-60 overflow-y-auto space-y-2">
        {supplierResponses
          .filter(s => s.response_status !== "Waiting for Response")
          .map(s => (
          <div
            key={s._id}
            className="p-3 border rounded-lg hover:bg-blue-50 cursor-pointer"
            onClick={() => {
              setSelectedSupplierForFinalPrice(s.vendor.id);
              handleGetFinalPrice("SPECIFIC", s.vendor.id);
            }}
          >
            <p className="font-semibold">{s.vendor.company_name}</p>
            <p className="text-sm text-gray-600">{s.vendor.name}</p>
          </div>
        ))}
      </div>

      <div className="flex justify-end mt-5">
        <button
          className="px-3 py-1 bg-gray-300 rounded hover:bg-gray-400"
          onClick={() => setFinalSupplierSelectPopup(false)}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}

 {showPopup && (
  <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
    <div className="bg-white w-full max-w-md rounded-xl shadow-2xl p-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h4 className="font-semibold text-lg">Give BuildCoins</h4>
        <button
          onClick={() => setShowPopup(false)}
          className="text-gray-500 hover:text-gray-800"
        >
          <X size={20} />
        </button>
      </div>

      {/* Input Field */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Enter BuildCoins
        </label>
        <input
          type="number"
          min="0"
          value={coinsToGive}
          onChange={(e) => setCoinsToGive(e.target.value)}
          className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="0"
        />
      </div>

      {/* Confirm Button */}
      <button
        type="button"
        className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow w-full disabled:opacity-50"
        onClick={handleGiveCoins}
        disabled={crediting || !coinsToGive}
      >
        {crediting ? 'Giving...' : 'Give'}
      </button>
    </div>
  </div>
)}

{showCreditResult && (
  <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50 p-4">
    <div className={`w-full max-w-sm rounded-lg p-4 shadow-xl ${creditResult.success ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'}`}>
      <div className="flex items-start gap-3">
        <div className="mt-0.5">
          {creditResult.success ? <CheckCircle className="text-green-600" /> : <X className="text-red-600" />}
        </div>
        <div className="flex-1">
          <p className={`font-semibold ${creditResult.success ? 'text-green-800' : 'text-red-800'}`}>{creditResult.success ? 'Success' : 'Failed'}</p>
          <p className="text-sm text-gray-700 mt-1">{creditResult.message}</p>
        </div>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default RFQsTable;
